import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const ChannelListContentContainer = styled.div<{ focused?: boolean }>`
  left: ${(props) => (props.focused ? 123 : 310) * Screen.widthRatio}px;
  position: fixed;
`;

export default withAnimation(ChannelListContentContainer);
